<template>
  <main class="[ flow ] [ gap-b-3 pad-b-start-3 ]">
    <section class="[ flow all-center ] [ gap-b-end-2 ]">
      <span class="text-6 leading-flat uppercase">
        {{ currentLetter.value }}
      </span>
      <Timer ref="timerRef" :time="timerDurationSeconds"></Timer>
    </section>
    <Button radius="true" @click="next" :disabled="activeLetters.length === 0">
      Nächster Buchstabe
    </Button>
  </main>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import Timer from "../components/block/Timer.vue";

export default {
  components: {
    Timer,
  },
  setup() {
    // Store instance
    const store = useStore();

    // Store the current selected letter
    const currentLetter = ref({ value: "Bereit?" });

    // Get all active letters
    const activeLetters = computed(() => {
      return store.getters.getActiveLetters;
    });

    // Get a random number between 0 and activeLetters length
    const randomLetterIndex = () => {
      return Math.floor(Math.random() * activeLetters.value.length);
    };

    // A ref to get access to childs methods
    const timerRef = ref(null);

    // Timer duration converted to seconds
    const timerDurationSeconds = computed(() => {
      // Get the timerDuration from Store
      const storedDuration = store.getters.getTimer;
      // Calculate seconds
      return storedDuration.value * 60;
    });

    const next = () => {
      // Return if no active letter left
      if (activeLetters.value.length === 0 || timerRef.value.timerStarted) {
        return;
      }

      // Get random index
      const index = randomLetterIndex();

      // Set currentLetter based on random number
      currentLetter.value = activeLetters.value[index];

      // Deactivate the current letter in the store
      store.dispatch("updateLetter", {
        value: currentLetter.value.value,
        active: false,
      });

      // Speak letter
      if ("speechSynthesis" in window) {
        const speech = new SpeechSynthesisUtterance();
        speech.text = currentLetter.value.value;
        window.speechSynthesis.speak(speech);
      }

      // Start timer
      timerRef.value.startTimer();
    };

    return {
      next,
      activeLetters,
      currentLetter,
      timerDurationSeconds,
      timerRef,
    };
  },
};
</script>
